enum ProEnum {
  SuitePrefix = 'A',
}

export default ProEnum
